module.exports = __webpack_public_path__ + "img/joinBg.47d96777.png";